export enum UrgencySignalsMessages {
    fewTickets = 'fewTickets',
    salesEndSoon = 'salesEndSoon',
}
export interface UrgencySignals {
    sortedMessages: Array<UrgencySignalsMessages>;
    messages: {
        fewTickets?: boolean;
        salesEndSoon?: boolean;
    };
}
